import { Injectable } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { Location } from '@angular/common';
import { filter } from 'rxjs/operators';
import { APP_ROUTES } from '@typings/app-routes.constant';

@Injectable({ providedIn: 'root' })
export class NavigationService {
  private history: string[] = [];

  constructor(private router: Router, private location: Location) {
    this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe((event: any) => {
        this.history.push(event.urlAfterRedirects);
      });
  }

  back(): void {
    this.history.pop(); // Remove current page
    if (this.history.length > 0) {
      this.location.back();
    } else {
      this.router.navigateByUrl(APP_ROUTES.authentication['sign-in'].fullPath);
    }
  }
}
